interface Unit {
  single: string;
  plural: string;
}

export const formatUnit = (value: number, unit: Unit): string => {
  const _unit = value === 1 ? unit.single : unit.plural;
  return `${value.toLocaleString("da-DK")}${
    _unit === "%" ? _unit : `\xa0${_unit}`
  }`;
};

export default Unit;
